module.exports = __webpack_public_path__ + "img/exim-logo.da98cc77.jpg";